// extracted by mini-css-extract-plugin
export var quillEditor = "_no-1";
export var variable = "_no-0";